<div class="lum-c-cost-layer-edit">
  <form
    *ngIf="editHelper.store.costLayer$ | async as costLayer"
    [formGroup]="editHelper.form"
  >
    <div class="lum-c-cost-layer-edit__basic">
      <div class="grow">
        <dl class="dl-grid dl-grid--inline gap-x-2">
          <dt class="h5 mb-1">SKU</dt>
          <dd class="h5 mb-1"
            ><a
              [routerLink]="['/inventory', costLayer.productId, 'view']"
              [queryParams]="{ v: 'costs' }"
              target="_blank"
              >{{ costLayer.product?.internalSku }}</a
            ></dd
          >

          <dt>At Warehouse</dt>
          <dd>{{ costLayer.warehouse?.locationName }}</dd>

          <dt>PO</dt>
          <dd>
            <a
              *ngIf="costLayer.purchaseOrder?.id; else whenNoPO"
              [routerLink]="['/orders', costLayer.purchaseOrder.id]"
            >
              #{{ costLayer.purchaseOrder?.id }}
            </a>
            <ng-template #whenNoPO>-</ng-template>
          </dd>

          <dt>Shipment</dt>
          <dd>
            <a
              *ngIf="costLayer.shipment?.id; else whenNoShipment"
              [routerLink]="['/orders/shipments', costLayer.shipment.id]"
            >
              #{{ costLayer.shipment?.id }}
            </a>
            <ng-template #whenNoShipment>-</ng-template>
          </dd>

          <dt>Receipt</dt>
          <dd>
            <button
              *ngIf="costLayer.receipt?.id; else whenNoReceipt"
              type="button"
              class="linkish"
              (click)="handleReceiptClick($event, costLayer.receipt?.id)"
            >
              #{{ costLayer.receipt?.id }}
            </button>
            <ng-template #whenNoReceipt>-</ng-template>
          </dd>
        </dl>

        <label class="form-group row">
          <span class="lum-label col-form-label col-5 col-sm-3 col-xl-2">
            Notes</span
          >
          <div class="col-6 col-sm-8 col-xl-9">
            <textarea
              class="form-control"
              rows="5.5"
              formControlName="description"
            ></textarea>
          </div>
        </label>
      </div>

      <div class="grow">
        <label class="form-group row">
          <span class="lum-label col-form-label col-5 col-sm-3 col-xl-2">
            Total Cost</span
          >
          <div class="col-7 col-sm-6 col-md-4 col-xl-3">
            <input
              type="text"
              class="form-control-plaintext text-right"
              [value]="editHelper.store.computedTotalCost$ | async | currency"
              readonly
            />
          </div>
        </label>

        <label class="form-group row">
          <span class="lum-label col-form-label col-4 col-sm-3 col-xl-2">
            Unit Cost</span
          >
          <div class="col-7 col-sm-6 col-md-4 col-xl-3">
            <input
              type="text"
              class="form-control text-right"
              inputmode="decimal"
              [attr.pattern]="editHelper.NUMBER_PATTERN"
              formControlName="costPerUnit"
            />
          </div>
        </label>

        <label class="form-group row">
          <span class="lum-label col-form-label col-4 col-sm-3 col-xl-2">
            Initial Qty</span
          >
          <div class="col-7 col-sm-6 col-md-4 col-xl-3">
            <input
              type="text"
              class="form-control text-right"
              inputmode="decimal"
              [attr.pattern]="editHelper.NUMBER_PATTERN"
              formControlName="initialQuantity"
            />
          </div>
        </label>

        <label class="form-group row">
          <span class="lum-label col-form-label col-4 col-sm-3 col-xl-2">
            Remaining Qty</span
          >
          <div class="col-7 col-sm-6 col-md-4 col-xl-3">
            <input
              type="text"
              class="form-control text-right"
              inputmode="decimal"
              [attr.pattern]="editHelper.NUMBER_PATTERN"
              formControlName="remainingQuantity"
            />
          </div>
        </label>
      </div>
    </div>
  </form>

  <div
    class="overlay"
    lumAppLoader
    [loading]="editHelper.store.costLayerLoadingOrSaving$ | async"
    classes="loading blur"
  ></div>
</div>
